

export default class {
    name = 'm2'
    data = {
        childName: '子名字不重要'
    }
}